import React from "react";
import ItemConsumptionList from "../items/item-consumption-list";
import { fetchWorkOrderItems, updateWorkOrderItem, addWorkOrderItems, deleteWorkOrderItem } from "../../../api/work-order";
import axios from "../../../api/axios";
/**
 * Work Order-specific wrapper for ItemConsumptionList
 * This component uses the generic ItemConsumptionList component
 */
const WorkOrderItemConsumptionList = ({
  items: initialItems = [],
  onItemsChange,
  disabled = false,
  workOrder,
  onWorkOrderUpdate,
  onItemsUpdate,
  onSubDialogStateChange,
}) => {
  // Wrapper function to fetch work order items
  const fetchItems = async (workOrderId) => {
    return await fetchWorkOrderItems(workOrderId);
  };

  // Wrapper function to update a single work order item
  const updateItem = async (workOrderId, item) => {
    return await updateWorkOrderItem(workOrderId, item);
  };

  // Wrapper function to add work order items (for bulk operations)
  const addItems = async (workOrderId, items) => {
    return await addWorkOrderItems(workOrderId, items);
  };

  // Wrapper function to delete a work order item
  const deleteItem = async (workOrderId, itemId) => {
    return await deleteWorkOrderItem(workOrderId, itemId);
  };

  // Wrapper function to update the work order (for bulk operations)
  // For work orders, we use the update endpoint with order_items (similar to reports with items)
  const updateModule = async (workOrderData) => {
    if (workOrderData.items && workOrderData.items.length > 0) {
      // Format items for the backend (order_items expects specific format)
      // Include ALL fields to prevent overwriting existing values with defaults
      const formattedItems = workOrderData.items.map(item => ({
        id: item.id || null,
        product_id: item.product_id || null,
        title: item.title || null,
        description: item.description || null,
        quantity: item.quantity || 0,
        sales_price: item.sales_price || null,
        purchase_price: item.purchase_price || null,
        discount: item.discount || null,
        surcharge: item.surcharge || null,
        unit_id: item.unit_id || null,
        group_row: item.group_row || null,
        is_quote_line: item.is_quote_line || false,
        delete: item.delete || false,
        // Include consumption-related fields to preserve existing values
        picked: item.picked !== undefined ? item.picked : false,
        picked_at: item.picked_at || null,
        taken_in_vehicle: item.taken_in_vehicle !== undefined ? item.taken_in_vehicle : false,
        not_used: item.not_used !== undefined ? item.not_used : false,
        quantity_used: item.quantity_used || null,
        quantity_not_used: item.quantity_not_used || null,
        returned_to_storage: item.returned_to_storage !== undefined ? item.returned_to_storage : false,
        left_in_vehicle: item.left_in_vehicle !== undefined ? item.left_in_vehicle : false,
        storage_id: item.storage_id || null,
        invoiced: item.invoiced !== undefined ? item.invoiced : false,
      }));
      
      // Use the update endpoint with order_items
      const response = await axios.put(`/work_orders/${workOrderData.id}`, {
        work_order: {
          order_items: formattedItems
        }
      });
      
      // Return response in the same format as updateReportAsync
      const workOrder = response.data?.data || response.data;
      return {
        data: {
          items: workOrder?.items || workOrderData.items,
        },
      };
    }
    return { data: { items: [] } };
  };

  return (
    <ItemConsumptionList
      items={initialItems}
      onItemsChange={onItemsChange}
      disabled={disabled}
      module={workOrder}
      moduleType="work_order"
      fetchItems={fetchItems}
      updateItem={updateItem}
      addItems={addItems}
      deleteItem={deleteItem}
      updateModule={updateModule}
      onModuleUpdate={onWorkOrderUpdate}
      onItemsUpdate={onItemsUpdate}
      onSubDialogStateChange={onSubDialogStateChange}
    />
  );
};

export default WorkOrderItemConsumptionList;
